import { render } from "./CaseReply.vue?vue&type=template&id=6fb2428c&scoped=true"
import script from "./CaseReply.vue?vue&type=script&lang=js"
export * from "./CaseReply.vue?vue&type=script&lang=js"

import "./CaseReply.vue?vue&type=style&index=0&id=6fb2428c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb2428c"]])

export default __exports__